import loginReducer from "./slices/loginSlice";
import OperationsHomeReducer from "./slices/operationHomeSlice";
import AgentHomeReducer from "./slices/agentHomeSlice";
import notificationReducer from "./slices/notificationSlice";

const rootReducers = {
  login: loginReducer,
  operationHome: OperationsHomeReducer,
  agentHome: AgentHomeReducer,
  notifications: notificationReducer,
};

export default rootReducers;
